import { VariantProduct } from '__generated__/graphql';
import { useTranslate } from 'hooks/useTranslations';

import { ConfirmModal } from './ConfirmModal';
import { Img } from './Img';

interface RemoveWishlistItemModalProps {
  onClickOutside: () => void;
  onConfirm: () => void;
  product: VariantProduct;
}

export const RemoveWishlistItemModal: React.FC<
  RemoveWishlistItemModalProps
> = props => {
  const { onClickOutside, onConfirm, product } = props;
  const t = useTranslate();

  return (
    <ConfirmModal onClickOutside={onClickOutside} onConfirm={onConfirm}>
      <h1 className="text-xl pr-8">{t('removeWishlistItemConfirmation')}</h1>
      <div className="flex items-center border p-4 space-x-4">
        <div className="w-40">
          <Img
            src={product.images[0].href.replace(/1000/g, '300')}
            alt={product.images[0].alt}
            width={160}
          />
        </div>

        <div className="space-y-2">
          <div>
            <div className="text-xs sm:text-sm md:text-base text-puma-black-300 pb-2">
              #{product.styleNumber}
            </div>
            <h2 className="font-bold text-puma-black text-sm sm:text-lg md:text-xl leading-xxs">
              {product.name}
            </h2>
            <span className="text-xs sm:text-sm !leading-[1em]">
              {product.colorName}
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="font-bold text-puma-black text-xs sm:text-sm uppercase">
              {t('size')}:
            </span>
            <span className="text-xs sm:text-sm">{product.size.label}</span>
          </div>
        </div>
      </div>
    </ConfirmModal>
  );
};
